module.exports = __webpack_public_path__ + "img/engagement-mobile@2x.6953af3.jpg";